
import _ from 'lodash';

import ko from 'rgs-knockout';


export function valid (validator, ...args) {
	return validator.validator(...args);
}

export function invalid (...args) {
	return !valid(...args);
}

export function findValid (validators, ...args) {
	return _.find(validators, (v) => valid(v, ...args));
}

export function findInvalid (validators, ...args) {
	return _.find(validators, (v) => invalid(v, ...args));
}

export function unwrap (f) {
	if (_.isFunction(f)) {
		return f();
	}
	return f;
}

export function unwrapParamsAccessor (paramsAccessor) {
	const params = unwrap(paramsAccessor);
	return params === undefined ? true : params;
}

export function unwrapFunction (f) {
	if (_.isFunction(f) && !ko.isObservable(f)) {
		return f();
	}
	return f;
}

export function unwrapObservableAccessor (f) {
	return ko.unwrap(unwrapFunction(f));
}

export function ignoreSpaces (v) {
	return v ? v.replace(/\s+/g, '') : v;
}
